<template>
  <div
    id="age"
    class="OrderDetailTabContainer u-mb20"
  >
    <!-- 享年 -->
    <label class="FormGroup-Label">5. 没年齢</label>
    <!-- 霊ごとの設定 -->
    <div v-if="form.columns.length">
      <div class="Columns" v-for="(column, index) in form.columns" :key="index">
        <div class="FormGroup u-mt10">
          <div class="subLabelAgeOfDeath">
            <label class="Columns-IndexLabel">{{ index + 1 }}霊目</label>
          </div>
          <!-- 享年表記 -->
          <div class="FormGroup">
            <label class="Columns-IndexLabel">
              享年表記
            </label>
            <div class="FormGroup-Form" style="margin-left: -90px;">
              <el-select
                style="width: 50%;"
                placeholder="選択"
                @change="_onClickAgeAtDeathPrefixCard($event, index)"
                :value="selectedAgeAtDeathPrefixes[index]"
              >
                <el-option :value="null" label="入れない"></el-option>
                <el-option
                  v-for="option in ageAtDeathPrefixes"
                  :key="option.label"
                  :label="option.label"
                  :value="option.value"
                >
                  {{ option.label }}</el-option
                >
              </el-select>
            </div>
          </div>
          <!-- 享年表記 その他 -->
          <div
            class="FormGroup"
            v-if="selectedAgeAtDeathPrefixes[index] === 'その他'"
          >
            <div class="FormGroup-Form" style="margin-right: 50%;">
              <RestrictedCharacterInput
                style="margin-left: 5%;"
                :value="$itaijiFM.getText(column.ageAtDeathPrefix)"
                pattern="IHAI_INPUT_PATTERN"
                @onChangeInput="_onChangeAgeAtDeathPrefixInput($event, index)"
                @onSubmit="_onChangeAgeAtDeathPrefixInput($event, index)"
              ></RestrictedCharacterInput>
            </div>
          </div>
        </div>
        <div
          v-if="form.columns.length > 1 && index + 1 != form.columns.length"
        ></div>
        <div class="Colums">
          <GridContainer :column="4">
            <div class="subLabelAgeOfDeathInput">
              <label class="Columns-IndexLabel">年齢</label>
            </div>
            <div class="FormGroup-Form Age-Of-Death-Input" style="flex: none;">
              <el-select
                style="margin-left: 5%;"
                placeholder="年齢"
                @change="_onChangeAgeAtDeath($event, index)"
                :value="$itaijiFM.getText(column.ageAtDeath)"
              >
                <el-option label="" value=""></el-option>
                <el-option
                  v-for="item in olds"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <!-- 年齢単位 -->
            <div class="FormGroup-Form">
              <ButtonGroup>
                <el-select
                  style="margin-top: 10px;"
                  placeholder="年齢単位"
                  @change="_onClickAgeUnitCharacter($event, index)"
                  :value="selectedAgeUnitCharacters[index]"
                >
                  <el-option :value="null" label="入れない"></el-option>
                  <el-option
                    v-for="option in ageUnitCharacters"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                    {{ option.label }}</el-option
                  >
                </el-select>
              </ButtonGroup>
            </div>
            <!-- 年齢単位 その他 -->
            <div
              class="FormGroup u-ml50"
              style="margin-top: 0rem; width: 100px;"
              v-if="selectedAgeUnitCharacters[index] === 'その他'"
            >
              <div class="FormGroup-Form">
                <RestrictedCharacterInput
                  :value="$itaijiFM.getText(column.ageUnitCharacter)"
                  pattern="IHAI_INPUT_PATTERN"
                  @onChangeInput="_onChangeAgeUnitCharacterInput($event, index)"
                  @onSubmit="_onChangeAgeUnitCharacterInput($event, index)"
                ></RestrictedCharacterInput>
              </div>
            </div>
          </GridContainer>
        </div>
      </div>
      <!-- 享年表記位置 -->
      <div>
        <div
          class="FormGroup"
          v-if="
            orderType.layout.id === 'n2-east-2' ||
            orderType.layout.id === 'n2-west'
          "
        >
          <label class="Columns-IndexLabel">享年表記位置</label>
          <div class="FormGroup-Form" id="ageAtDeathPlacementButton">
            <ButtonGroup>
              <el-select
                placeholder="選択"
                @change="_onClickAgeAtDeathPlacementButton($event)"
                :value="form.ageAtDeathPrefixPlacement"
              >
                <el-option :value="{}" label="未選択"></el-option>
                <el-option
                  v-for="option in ageAtDeathPrefixPlacement"
                  :key="option.label"
                  :label="option.label"
                  :value="option.value"
                >
                  {{ option.label }}</el-option
                >
              </el-select>
            </ButtonGroup>
          </div>
        </div>
      </div>
    </div>

    <!-- 裏梵字 -->
    <div class="u-line u-line--dashed" />
    <label class="FormGroup-Label">6. 裏梵字</label>
    <div
      v-if="!isMindAlte"
      class="FormGroup"
    >
      <div class="FormGroup-Form">
        <el-select
          style="margin-bottom: 3px;padding-right: 20px;"
          placeholder="選択"
          @change="_onClickSanskritCharacterBackCard($event)"
          :value="form.isSanskritCharacterBackNeeded"
        >
          <el-option
            v-for="option in addOrNot"
            :key="option.label"
            :label="option.label"
            :value="option.value"
          >
            {{ option.label }}</el-option
          >
        </el-select>
        <div class="sanskirtCard" v-if="form.isSanskritCharacterBackNeeded">
          <div class="FormGroup">
            <div class="FormGroup-SanskritCharacterSelect">
              <el-button
                class="choseDefaultButton"
                @click="onClickOpenSanskritCharacterBackModal"
                type="primary"
                >梵字画像から選択</el-button
              >
              <el-upload
                class="AddAttachmentButton"
                ref="upload"
                action
                :auto-upload="false"
                :on-change="_onChangeSanskritCharacterCustomImage"
                accept=".jpg, .png"
                :show-file-list="false"
                :multiple="false"
              >
                <el-button class="DirectUploadButton" type="primary"
                  >直接画像を選択</el-button
                >
              </el-upload>
              <el-dialog
                title="梵字選択"
                :visible.sync="sanskritCharacterBackDialogVisible"
                width="90%"
                top="1vh"
              >
                <div class="characterCardWrapper">
                  <GridContainer :column="4">
                    <CharacterCard
                      v-for="character in sanskritCharacters"
                      :key="character.id"
                      :data="character.id"
                      :isActive="
                        form.sanskritCharacterBack &&
                          form.sanskritCharacterBack.id === character.id
                      "
                      @click="_onClickSanskritCharacterBack(character)"
                      :text="character.sect"
                      :image="character.imageUrl"
                    />
                  </GridContainer>
                </div>
              </el-dialog>
            </div>
          </div>
          <div class="sanskritCharactersImages">
            <div
              v-if="form.customSanskritCharacterBackUrl"
              class="FormGroup u-mt10 u-ml50"
            >
              <label class="FormGroup-Label">裏梵字の画像</label>
              <div class="FormGroup-Form FormGroup-Form--LeftAlign">
                <img
                  class="CustomSanskritCharacterBackPreview"
                  :src="customSanskritCharacterBackUrlLocal"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 施主 -->
    <div v-if="layoutObj.layout.id === 'm1-b'">
      <div class="u-line u-line--dashed" />
      <label class="FormGroup-Label">7. 施主</label>
      <div class="FormGroup u-mt10">
        <div class="subLabelSecularName">
            <label class="Columns-IndexLabel">施主名</label>
          </div>
          <div class="u-mt10">
            <RestrictedCharacterInput
              :value="$itaijiFM.getText(form.hostName)"
              label="施主名"
              class="Host-Name-Input"
              pattern="IHAI_INPUT_PATTERN"
              @onChangeInput="_onChangeHostName($event)"
              @onSubmit="_onChangeHostName($event)"
            />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { produce } from "immer";
import { mapState, mapGetters } from "vuex";

// Data Handler
import EntityFactory from "@/entities/entity.factory";
import RestrictedCharacterInput from "@/components/RestrictedCharacterInput";

import ButtonGroup from "@/components/ButtonGroup";
import CharacterCard from "@/components/CharacterCard";
import GridContainer from "@/components/GridContainer";

import OrderFormUsecase from "@/usecases/orderForm.usecase";
import FileUsecase from "@/usecases/file.usecase";
import SanskritCharacterUsecase from "@/usecases/sanskritcharacter.usecase";

import SAMPLE_URL from "../const/samplePictUrl.js";

const orderOption = EntityFactory.create("orderOption");
const olds = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
  "十一",
  "十二",
  "十三",
  "十四",
  "十五",
  "十六",
  "十七",
  "十八",
  "十九",
  "二十",
  "二十一",
  "二十二",
  "二十三",
  "二十四",
  "二十五",
  "二十六",
  "二十七",
  "二十八",
  "二十九",
  "廿",
  "廿一",
  "廿二",
  "廿三",
  "廿四",
  "廿五",
  "廿六",
  "廿七",
  "廿八",
  "廿九",
  "三十",
  "三十一",
  "三十二",
  "三十三",
  "三十四",
  "三十五",
  "三十六",
  "三十七",
  "三十八",
  "三十九",
  "丗",
  "丗一",
  "丗二",
  "丗三",
  "丗四",
  "丗五",
  "丗六",
  "丗七",
  "丗八",
  "丗九",
  "四十",
  "四十一",
  "四十二",
  "四十三",
  "四十四",
  "四十五",
  "四十六",
  "四十七",
  "四十八",
  "四十九",
  "五十",
  "五十一",
  "五十二",
  "五十三",
  "五十四",
  "五十五",
  "五十六",
  "五十七",
  "五十八",
  "五十九",
  "六十",
  "六十一",
  "六十二",
  "六十三",
  "六十四",
  "六十五",
  "六十六",
  "六十七",
  "六十八",
  "六十九",
  "七十",
  "七十一",
  "七十二",
  "七十三",
  "七十四",
  "七十五",
  "七十六",
  "七十七",
  "七十八",
  "七十九",
  "八十",
  "八十一",
  "八十二",
  "八十三",
  "八十四",
  "八十五",
  "八十六",
  "八十七",
  "八十八",
  "八十九",
  "九十",
  "九十一",
  "九十二",
  "九十三",
  "九十四",
  "九十五",
  "九十六",
  "九十七",
  "九十八",
  "九十九",
  "百",
  "百一",
  "百二",
  "百三",
  "百四",
  "百五",
  "百六",
  "百七",
  "百八",
  "百九",
  "百十",
  "百十一",
  "百十二",
  "百十三",
  "百十四",
  "百十五",
  "百十六",
  "百十七",
  "百十八",
  "百十九",
  "百二十",
  "百廿",
];

export default {
  components: {
    ButtonGroup,
    CharacterCard,
    GridContainer,
    RestrictedCharacterInput,
  },
  async created () {
    const charactersResult = await usecase.sanskritCharacter.getSanskritCharacters();
    this.sanskritCharacters = charactersResult.data.sanskritCharacters;
    this.ageAtDeathPrefixes = await usecase.orderForm.getAgeAtDeathPrefixes();
    await this.syncCustomSanskritCharacterBackUrlLocal();
    this.initAgeAtDeathPrefix();
    this.initAgeUnitCharacter();
  },
  mounted () {},
  data () {
    return {
      olds,
      addOrNot: orderOption.addOrNot,
      sanskritCharacters: [],
      sanskritCharacterBackDialogVisible: false,
      customSanskritCharacterBackUrlLocal: null,
      sanskritCharacterOrFamilyEmblemOptions:
        orderOption.sanskritCharacterOrFamilyEmblem,
      selectedAgeAtDeathPrefixes: [null, null],
      selectedAgeUnitCharacters: [null, null],
      ageAtDeathPrefixes: [],
      ageUnitCharacters: orderOption.ageUnitCharacters,
      ageAtDeathPrefixPlacement: orderOption.ageAtDeathPrefixPlacement,
    };
  },
  computed: {
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
    }),
    ...mapGetters({
      filteredFavoriteVariantCharacters: "orderForm/getFilteredFavoriteVariantCharacters",
      isMindAlte: "orderForm/isMindAlte",
    }),
    form: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
    layoutObj: {
      get () {
        return this.$store.state.orderForm.orderTypeInput;
      },
    },
  },
  watch: {},
  updated () {
    // this.commit();
  },
  methods: {
    async syncCustomSanskritCharacterBackUrlLocal () {
      if (this.form.customSanskritCharacterBackUrl) {
        this.customSanskritCharacterBackUrlLocal = await usecase.file.fetchURL(
          this.form.customSanskritCharacterBackUrl
        );
        this.form.isSanskritCharacterBackNeeded = true;
        this.form.sanskritCharacterBack = {
          id: "uploadImg",
          sect: "ユーザー選択画像(裏梵字)",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
          inputCode: "",
          imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
        };
      }
    },
    _onClickSanskritCharacterBackCard (isSanskritCharacterBackNeeded) {
      this.form = { ...this.form, ...{ isSanskritCharacterBackNeeded } };
    },
    _onClickSanskritCharacterBack (character) {
      this.form = { ...this.form, sanskritCharacterBack: character };
      this.form.sanskritCharacter = character
        ? this.form.sanskritCharacter
        : null;
      this.sanskritCharacterBackDialogVisible = false;
    },
    _onClickSelectSanskritImage () {
      // custom urlを初期化
      this.form.customSanskritCharacterBackUrl = null;
      this.customSanskritCharacterBackUrlLocal = null;
    },
    onClickOpenSanskritCharacterBackModal () {
      this.isCustomSanskritCharacter = false;
      this.sanskritCharacterBackDialogVisible = true;
    },

    /**
     * [_onChangeSanskritCharacterCustomImage description]
     * @param   {[type]}  file      [file description]
     * @param   {[type]}  fileList  [fileList description]
     * @return  {[type]}            [return description]
     */
    async _onChangeSanskritCharacterCustomImage (file, fileList) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // 元々指定がなかっため max: 5GB までのファイルを扱う
      if (!usecase.file.validateFileSize(file, "max")) {
        // Clear file list
        this.$refs.upload.clearFiles();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "sanskritCharacterBack";

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw);

        // file.serviceで画像を取得。aws上のトークンつき画像URLをソースとし表示
        this.form.customSanskritCharacterBackUrl = result.key;
        this.customSanskritCharacterBackUrlLocal = await usecase.file.fetchURL(result.key);

        // プレビュー用の画像の表示
        this.form.isSanskritCharacterBackNeeded = true;
        this.form.sanskritCharacterBack = {
          id: "uploadImg",
          sect: "ユーザー選択画像(裏梵字)",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
          inputCode: "",
          imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
        };
      } catch (err) {
        console.log(err);

        // Clear file list
        this.$refs.upload.clearFiles();
      }
    },
    // When you tap the 中央or霊ごと
    _onClickAgeAtDeathPlacementButton (value) {
      this.form = { ...this.form, ...{ ageAtDeathPrefixPlacement: value } };
    },
    initAgeAtDeathPrefix () {
      // Vue 2 は配列の index 代入を検知しないため、配列ごと差し替える
      this.selectedAgeAtDeathPrefixes = this.form.columns.map(column => {
        const { ageAtDeathPrefix } = column;
        if (ageAtDeathPrefix && !ageAtDeathPrefix.length) {
          return null;
        }
        const text = this.$itaijiFM.getText(ageAtDeathPrefix);
        if (
          !this.ageAtDeathPrefixes.filter(el => el.label === text).length
        ) {
          if (ageAtDeathPrefix && ageAtDeathPrefix.length) {
            return "その他";
          }
        }
        return text || null;
      });
    },
    initAgeUnitCharacter () {
      // Vue 2 は配列の index 代入を検知しないため、配列ごと差し替える
      this.selectedAgeUnitCharacters = this.form.columns.map(column => {
        const { ageUnitCharacter } = column;
        if (ageUnitCharacter && !ageUnitCharacter.length) {
          return null;
        }
        const text = this.$itaijiFM.getText(ageUnitCharacter);
        if (
          !this.ageUnitCharacters.filter(el => el.label === text).length
        ) {
          if (ageUnitCharacter && ageUnitCharacter.length) {
            return "その他";
          }
        }
        return text || null;
      });
    },
    _onClickAgeAtDeathPrefixCard (ageAtDeathPrefix, index) {
      const { toItaiji } = this.$itaijiFM;

      this.selectedAgeAtDeathPrefixes[index] = ageAtDeathPrefix;
      if (ageAtDeathPrefix !== "その他") {
        this.form = produce(this.form, d => {
          d.columns[index].ageAtDeathPrefix = toItaiji(ageAtDeathPrefix, this.filteredFavoriteVariantCharacters);
        });
      } else {
        this.form = produce(this.form, d => {
          d.columns[index].ageAtDeathPrefix = "";
        });
      }
    },
    _onChangeAgeAtDeathPrefixInput (ageAtDeathPrefix, index) {
      const { toItaiji } = this.$itaijiFM;

      this.form = produce(this.form, d => {
        d.columns[index].ageAtDeathPrefix = toItaiji(ageAtDeathPrefix, this.filteredFavoriteVariantCharacters);
      });
    },
    _onClickAgeUnitCharacter (ageUnitCharacter, index) {
      const { toItaiji } = this.$itaijiFM;

      this.selectedAgeUnitCharacters[index] = ageUnitCharacter;
      if (ageUnitCharacter !== "その他") {
        this.form = produce(this.form, d => {
          d.columns[index].ageUnitCharacter = toItaiji(ageUnitCharacter, this.filteredFavoriteVariantCharacters);
        });
      } else {
        this.form = produce(this.form, d => {
          d.columns[index].ageUnitCharacter = "";
        });
      }
    },
    _onChangeAgeUnitCharacterInput (ageUnitCharacter, index) {
      const { toItaiji } = this.$itaijiFM;

      this.form = produce(this.form, d => {
        d.columns[index].ageUnitCharacter = toItaiji(ageUnitCharacter, this.filteredFavoriteVariantCharacters);
      });
    },
    _onChangeAgeAtDeath (ageAtDeath, index) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.columns[index].ageAtDeath = toItaiji(ageAtDeath, this.filteredFavoriteVariantCharacters);
      });
    },
    _onChangeHostName (hostName) {
      const { toItaiji } = this.$itaijiFM;

      this.form = produce(this.form, d => {
        d.hostName = toItaiji(hostName);
      });
    },

    commit () {
      // const { form } = this;
      // const params = { ...form };
      // this.$store.commit("orderForm/updateDetail", params);
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.orderForm = new OrderFormUsecase();
    usecase.sanskritCharacter = new SanskritCharacterUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.OrderDetailTabContainer > * + * {
  margin-top: 10px;
}
.FormGroup-SanskritCharacterSelect {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.FormGroup-SanskritCharacterSelect .choseDefaultButton {
  margin-right: 10px;
}
.sanskritCharactersImages {
  margin-top: 10px;
}

.sanskritCharactersImages .CustomSanskritCharacterBackPreview {
  background: black;
  width: 80px;
}
.subLabelAgeOfDeath {
  margin-right: 5%;
  margin-top: 7px;
}
.subLabelAgeOfDeathInput {
  margin-right: 5%;
  margin-top: 15px;
}

.Host-Name-Input {
  width: 220%;
}
// .Age-Of-Death-Input {
//   /* justify-content: flex-start; */
// }
</style>
